export const redirect = (url) => {
  window.location.href = url;
};
